import styled from 'styled-components';

export const HeaderContainer = styled.div`
  width: 100%;
  margin-bottom: 32px;

  @media (max-width: 768px) {
    margin-bottom: 24px;
  }
`;

export const StepIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
  background: ${(props) =>
    props.theme?.colors?.card?.background ||
    (props.theme.name === 'dark'
      ? 'rgba(255, 255, 255, 0.05)'
      : 'rgba(255, 255, 255, 0.95)')};
  border: 1px solid
    ${(props) =>
      props.theme?.colors?.card?.border ||
      (props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.1)'
        : 'rgb(226, 232, 240)')};
  box-shadow: ${(props) =>
    props.theme?.colors?.card?.shadow ||
    (props.theme.name === 'dark'
      ? 'rgba(0, 0, 0, 0.2) 0px 1px 3px'
      : 'rgba(0, 0, 0, 0.1) 0px 1px 3px')};
  border-radius: 8px;

  @media (max-width: 768px) {
    padding: 16px;
    gap: 12px;

    .spacer {
      display: none;
    }
  }
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.2)'
        : 'rgba(0,0,0,0.1)'};
  border-radius: 8px;
  padding: 8px 16px;
  color: ${(props) => (props.theme.name === 'dark' ? '#E5E7EB' : '#6B7280')};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;

  &:hover {
    background: ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.05)'
        : 'rgba(0,0,0,0.03)'};
    border-color: ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.3)'
        : 'rgba(0,0,0,0.2)'};
  }

  @media (max-width: 768px) {
    padding: 8px 12px;

    .back-label {
      display: none;
    }
  }
`;

export const StepsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
  flex: 1;
  justify-content: center;
`;

export const Step = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StepNumber = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${(props) =>
    props.active || props.completed
      ? props.theme?.colors?.primary || '#FA4616'
      : props.theme.name === 'dark'
      ? '#374151'
      : '#E5E7EB'};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }
`;

export const StepLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${(props) =>
    props.active || props.completed
      ? props.theme.name === 'dark'
        ? '#ffffff'
        : props.theme.colors.blueBlack
      : props.theme.name === 'dark'
      ? '#64748B'
      : '#9CA3AF'};

  @media (max-width: 640px) {
    display: none;
  }
`;

export const StepConnector = styled.div`
  height: 2px;
  width: 100px;
  background: ${(props) =>
    props.completed
      ? props.theme?.colors?.primary || '#FA4616'
      : props.theme.name === 'dark'
      ? '#374151'
      : '#E5E7EB'};
  margin: 0 12px;

  @media (max-width: 768px) {
    width: 80px;
    margin: 0 12px;
  }

  @media (max-width: 480px) {
    width: 60px;
    margin: 0 10px;
  }
`;
